import type { GetGenerationVideosSettingsApiResponse } from '~services/api/generation';

const apiBase = process.env.PUBLIC_API ?? 'https://api.ifriend.ai';

const DAY_HALF = 60 * 60 * 12;

export const getGenerationVideosSettings = async (params?: RequestInit) => {
	const response = await fetch(`${apiBase}/ai/generation/videos/settings`, {
		...params,
		next: {
			revalidate: DAY_HALF,
			...params?.next,
			tags: ['generation-videos-settings'],
		},
	});

	if (!response.ok) {
		throw new Error(`Error fetching videos settings`);
	}

	const data =
		(await response.json()) as GetGenerationVideosSettingsApiResponse;

	return prepareGenerationVideosSettingsData(data);
};

export const prepareGenerationVideosSettingsData = (
	data: GetGenerationVideosSettingsApiResponse
): GetGenerationVideosSettingsApiResponse => ({
	...data,
	actions: data.actions || [],
});
